import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaFileContract, FaBalanceScale, FaGavel, FaFileSignature, FaBuilding
} from 'react-icons/fa';

// ✅ Merge existing + new services
const services = [
  // Existing ones (kept as-is)
  {
    icon: <FaFileContract size={40} />,
    title: "E-Stamp Paper",
    description: "Purchase legally valid electronic stamp papers.",
    path: "/e-stamp"
  },
  {
    icon: <FaBalanceScale size={40} />,
    title: "Legal Opinion",
    description: "Expert legal advice on various matters.",
    path: "/legal-opinion"
  },
  {
    icon: <FaGavel size={40} />,
    title: "Legal Services",
    description: "Comprehensive legal services tailored to your needs.",
    path: "/legal-service"
  },
  {
    icon: <FaFileSignature size={40} />,
    title: "Sale Agreement Registration",
    description: "Secure your property transactions with a registered sale agreement.",
    path: "/property-register"
  },
  {
    icon: <FaFileSignature size={40} />,
    title: "Marriage Registration",
    description: "Legally validate your marriage with official registration.",
    path: "/marriage-registration"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "LLP Registration",
    description: "Limited Liability Partnership registration services.",
    path: "/llp-registration"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "GST Registration",
    description: "Get your business registered for Goods and Services Tax.",
    path: "/gst"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "TDS Filing (Citizen & NRI)",
    description: "Filing Tax Deducted at Source for citizens and NRIs.",
    path: "/itrs-tds"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "Private Ltd Registration",
    description: "Register your Private Limited Company legally.",
    path: "/private-ltd-registration"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "EC Certified Copies",
    description: "Extract EC and certified documents easily.",
    path: "/ec-certified-copies"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "PAN Card",
    description: "PAN Card documentation and application services.",
    path: "/pancard"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "Revenue Certificates",
    description: "Income, caste, domicile, and more.",
    path: "/revenue-documents"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "Katha Transfer",
    description: "Transfer Katha & Tax in your name.",
    path: "/katha-tax-transfer"
  },
  {
    icon: <FaBalanceScale size={40} />,
    title: "Notary Public",
    description: "Official legal witnessing and certification of documents.",
    path: "/services"
  },

  // ✅ Extra from your new list (added if missing)
  {
    icon: <FaBalanceScale size={40} />,
    title: "PROPERTY REGISTRATIONS",
    description: "All types of property registration services.",
    path: "/property-register"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "E-STAMP TO YOUR DOORSTEP",
    description: "E-stamp delivery at your convenience.",
    path: "/e-stamp"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "PAN Card, Aadhaar Updation, Passport, Voter ID, Gazette",
    description: "End-to-end support for essential ID documents.",
    path: "/pancard"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "CERTIFIED COPIES OF REVENUE DOCUMENTS",
    description: "Form DC/AC, Tahsildar & Survey Office documents.",
    path: "/revenue-documents"
  },
  {
    icon: <FaFileContract size={40} />,
    title: "Encumbrance Certificate / Registered Deeds Certified Copies",
    description: "Get Encumbrance Certificates & Registered Deeds.",
    path: "/ec-certified-copies"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "LLP Name Approval, LLP Registration",
    description: "Complete LLP setup with approvals & compliance.",
    path: "/llp-registration"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "Pvt Ltd Company Registration, Digital Signature",
    description: "Private Ltd registration with DSC assistance.",
    path: "/private-ltd-registration"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "GST, GST Filing",
    description: "GST registration and periodic filing services.",
    path: "/gst"
  },
  {
    icon: <FaBuilding size={40} />,
    title: "ITRs, TDS, TDS Filing",
    description: "Income Tax Return filing & TDS compliance.",
    path: "/itrs-tds"
  },
];

const Service = () => {
  return (
    <div className='-mb-10'>
      <section className="flex items-center justify-center bg-white px-10 py-16">
        <div className="w-full text-center">
          <h2 className="text-5xl font-bold relative">
            <span className="text-[#b7b7a1] relative"> Our Services</span>
          </h2>
          <p className="text-gray-600 text-lg mt-4">
            Reliable and expert legal documentation services.
          </p>
        </div>
      </section>

      <div className="py-16 bg-[#F4F5EF] text-center">
        <h4 className="text-sm tracking-widest text-gray-500 uppercase">
          - Guidance. Advocacy. Results -
        </h4>
        <h2 className="text-4xl font-serif font-semibold mt-2">
          Expert Legal Solutions Tailored <span className="text-[#b7b7a1]">To</span> Your Specific Needs
        </h2>

        {/* ✅ Service Grid */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {services.map((service, index) => (
            <Link to={service.path} key={index}>
              <div className="flex flex-col items-center border-l-2 border-[#b7b7a1] cursor-pointer px-6 py-6 transition-all duration-300 hover:bg-[#b7b7a1]/60 hover:text-white">
                <div className="text-gray-800 mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold text-center">{service.title}</h3>
                <p className="mt-2 text-sm text-center hover:text-white">{service.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="py-10 bg-[#b7b7a1] text-center text-white">
        <h2 className="text-3xl font-bold">
          Document Registrations @ all Sub-Registrar Offices in  Bangalore & nearby districts
        </h2>
        <p className="text-lg mt-4">Ensuring legal compliance and hassle-free registration processes.</p>
      </div>
    </div>
  );
};

export default Service;
